import type { connection_bool_exp } from '@vrplatform/graphql';

export const whereConnectionStatusDefault: connection_bool_exp['status'] = {
  _eq: 'active',
};
